import { CSSProperties } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-common-types";
import {
  faCalendarAlt,
  faCircleQuestion,
  faDiagramProject,
  faFileContract,
  faFlag,
  faHouse,
  faIdCard,
  faLocationDot,
  faRoute,
  faShield,
  faTruck,
  faUserCheck,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import {
  BreadcrumbComponentProps,
  BreadcrumbComponentType,
  BreadcrumbsRoute,
} from "use-react-router-breadcrumbs";
import { Stack, Typography } from "@mui/material";
import {
  bidPackUrls,
  carrierUrls,
  contactUrls,
  edcUrls,
  ftlRouteUrls,
  odcUrls,
  plantUrls,
  projectUrls,
  proposedFtlRouteUrls,
  rateAgreementUrls,
  returnNetworkUrls,
  supplierUrls,
  ttProtectionUrls,
  validationBacklogUrls,
} from "../../URL/ApplicationUrls";
import { bidPackObjectName } from "../../StaticNetwork/BidPacks/BidPack";

const iconOnlyStyle: CSSProperties = { margin: "1px", fontSize: 12 };
const iconWithTextStyle: CSSProperties = {
  margin: "1px",
  marginBottom: "5px",
  fontSize: 12,
};

const DisplayTextOnly: BreadcrumbComponentType = ({ breadcrumbText }: BreadcrumbComponentProps) => (
  <Typography variant="body1" color="text.primary">
    {breadcrumbText}
  </Typography>
);

const DisplayIconWithText: BreadcrumbComponentType = ({
  breadcrumbText,
  breadcrumbIcon,
}: BreadcrumbComponentProps) => (
  <Stack
    direction="row"
    justifyContent="grid-start"
    alignItems="center"
    alignContent="center"
    spacing={1}
  >
    <FontAwesomeIcon icon={breadcrumbIcon as IconDefinition} style={iconWithTextStyle} />
    <Typography variant="body1" color="text.primary">
      {breadcrumbText}
    </Typography>
  </Stack>
);

const DisplayIconOnly: BreadcrumbComponentType = ({ breadcrumbIcon }: BreadcrumbComponentProps) => (
  <FontAwesomeIcon icon={breadcrumbIcon as IconDefinition} style={iconOnlyStyle} />
);

const DisplayDynamicText: BreadcrumbComponentType = ({ match }) => (
  <Typography variant="body1" color="text.primary">
    {match.params.id}
  </Typography>
);

export const MdmBreadcrumbsRoutes: BreadcrumbsRoute[] = [
  {
    path: "/",
    breadcrumb: DisplayIconOnly,
    props: {
      breadcrumbText: "Home",
      breadcrumbIcon: faHouse,
    },
  },
  {
    path: "/WhoAmI",
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "WhoAmI",
      breadcrumbIcon: faCircleQuestion,
    },
  },

  // Carriers
  {
    path: carrierUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Carrier",
      breadcrumbIcon: faTruck,
    },
  },

  // Locations
  {
    path: supplierUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Supplier",
      breadcrumbIcon: faWarehouse,
    },
  },
  {
    path: plantUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Plant",
      breadcrumbIcon: faWarehouse,
    },
  },
  {
    path: edcUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "EDC",
      breadcrumbIcon: faWarehouse,
    },
  },
  {
    path: odcUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "ODC & Other",
      breadcrumbIcon: faWarehouse,
    },
  },

  // Contacts
  {
    path: contactUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Contact",
      breadcrumbIcon: faIdCard,
    },
  },

  // Rate & Region
  {
    path: bidPackUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: bidPackObjectName,
      breadcrumbIcon: faLocationDot,
    },
  },
  {
    path: rateAgreementUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Rate Agreement",
      breadcrumbIcon: faFileContract,
    },
  },
  {
    path: `${rateAgreementUrls.base.uiPath}/:id`,
    breadcrumb: DisplayDynamicText,
    props: {
      noLink: true,
    },
  },

  // Transport network
  {
    path: returnNetworkUrls.pdsrOverview.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "PDSR",
      breadcrumbIcon: faFlag,
    },
  },
  {
    path: ttProtectionUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "TT Protection",
      breadcrumbIcon: faShield,
    },
  },

  // Routes
  {
    path: ftlRouteUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "FTL Routes",
      breadcrumbIcon: faRoute,
    },
  },
  {
    path: proposedFtlRouteUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Proposed FTL Routes",
      breadcrumbIcon: faCalendarAlt,
    },
  },

  // Projects
  {
    path: projectUrls.base.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "Projects",
      breadcrumbIcon: faDiagramProject,
    },
  },

  // Validation Backlog
  {
    path: validationBacklogUrls.pdsrs.uiPath,
    breadcrumb: DisplayIconWithText,
    props: {
      breadcrumbText: "PDSR Validation",
      breadcrumbIcon: faUserCheck,
    },
  },
];
